import { render, staticRenderFns } from "./RegisterEmailValidate.vue?vue&type=template&id=319c7723&scoped=true&"
import script from "./RegisterEmailValidate.vue?vue&type=script&lang=js&"
export * from "./RegisterEmailValidate.vue?vue&type=script&lang=js&"
import style0 from "./RegisterEmailValidate.vue?vue&type=style&index=0&id=319c7723&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319c7723",
  null
  
)

export default component.exports